webpackJsonp([22],{

/***/ 1042:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_events_vue__ = __webpack_require__(1095);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_213fbd2d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_events_vue__ = __webpack_require__(1151);
function injectStyle (ssrContext) {
  __webpack_require__(1149)
}
var normalizeComponent = __webpack_require__(24)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_events_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_213fbd2d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_events_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1095:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slick__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_internet_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_constant_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_constant_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__helper_constant_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_1_vue_slick__["default"]
  },
  data: function data() {
    return {
      moment: __WEBPACK_IMPORTED_MODULE_4_moment___default.a,
      homeSlider: {
        arrows: true,
        slidesToShow: 1,
        centerMode: true,
        centerPadding: "3.5%",
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 7000,
        responsive: [{
          breakpoint: 992,
          settings: {
            arrows: false,
            dots: true,
            centerMode: false,
            slidesToShow: 1,
            autoplaySpeed: 7000,
            autoplay: true,
            slidesToScroll: 1
          }
        }]
      },
      eventBanners: [],
      nowShowingEvents: [],
      upCommingEvents: [],
      allShowingEvents: [],
      base_url: "",
      url: __WEBPACK_IMPORTED_MODULE_3__helper_constant_js__["EVENT_URL"]
    };
  },
  beforeMount: function beforeMount() {
    metaInfo.title = "Book Tickets Online for all the Bahrain Events | WanasaTime";
    metaInfo.meta[2].content = "Book tickets online for all the upcoming Bahrain events on GCC's online ticket booking platform, WanasaTime";

    metaInfo.meta[3].content = "bahrain events, upcoming events in bahrain, events in bahrain today";
  },
  mounted: function mounted() {
    this.getAllData();
  },

  methods: {
    getAllData: function getAllData() {
      var _this = this;

      this.showLoading();

      Object(__WEBPACK_IMPORTED_MODULE_2__helper_internet_js__["makeRequest"])("/v1/event/getAllEvent", "POST", null, null, this.url).then(function (response) {
        var error = response.error,
            res = response.res;

        if (!error) {
          _this.hideLoading();

          console.log(res);
          _this.base_url = res.data.base_url;
          _this.eventBanners = res.data.banners;
          _this.upCommingEvents = res.data.comming_soon;
          _this.nowShowingEvents = res.data.now_showing;
          _this.allShowingEvents = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(res.data.comming_soon), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(res.data.now_showing));
        } else {
          console.log("Response Error ");
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    goToEventDetails: function goToEventDetails(data, type) {
      if (type == "banner") {
        if (data.eh_banner_url != "") {
          window.open(data.eh_banner_url, "_blank");
          // window.location = data.eh_banner_url;
        } else {
          this.$router.push({
            name: "eventDetails",
            params: {
              eventID: data.event_id
            }
          });
        }
      } else {
        this.$router.push({
          name: "eventDetails",
          params: {
            eventID: data.event_id
          }
        });
      }
    }
  }
});

/***/ }),

/***/ 1149:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1150);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1036)("60529c41", content, true, {});

/***/ }),

/***/ 1150:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1035)(true);
// imports


// module
exports.push([module.i, ".section-banner .slick-prev{left:5%}", "", {"version":3,"sources":["/var/www/html/cineco/website/vue-pwa-initial-setup/src/components/pages/events.vue"],"names":[],"mappings":"AACA,4BACE,OAAS,CACV","file":"events.vue","sourcesContent":["\n.section-banner .slick-prev {\n  left: 5%;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1151:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section-banner"},[(_vm.eventBanners.length > 0)?_c('Slick',{ref:"bannerSlick",attrs:{"options":_vm.homeSlider}},_vm._l((this.eventBanners),function(data,index){return _c('div',{key:index},[_c('div',{staticClass:"bannerContainer",on:{"click":function($event){return _vm.goToEventDetails(data, 'banner')}}},[_c('img',{attrs:{"src":_vm.base_url + data.eh_banner_image}})])])}),0):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"wrapper py-5 mt-4 home-movie-event-view"},[_c('div',{staticClass:"col-xl-11 mx-auto p-0"},[_c('div',{staticClass:"section-title d-none d-md-block"},[_vm._v("Events For You")]),_vm._v(" "),_c('b-tabs',{staticClass:"user-profile-tabs profile-tabs events-tabs",attrs:{"content-class":""}},[_c('b-tab',{attrs:{"title":"Now Showing"}},[_c('div',{staticClass:"row row-flex event-row-left-right row-cols-4"},_vm._l((this.nowShowingEvents),function(data,index){return _c('div',{key:index,staticClass:"col-6 col-sm-4 col-md-3 col-lg-3 px-lg-1 px-2"},[_c('div',{staticClass:"event-card",on:{"click":function($event){return _vm.goToEventDetails(data)}}},[_c('img',{staticClass:"w-100 event-image-ht",attrs:{"src":_vm.base_url + data.e_image}}),_vm._v(" "),_c('div',{staticClass:"middle"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t("BOOK_NOW")))])]),_vm._v(" "),_c('div',{staticClass:"event-card-details"},[_c('div',[_c('h6',{staticClass:"mb-0 text-truncate text-mobile-head"},[_vm._v("\n                      "+_vm._s(data.e_name)+"\n                    ")]),_vm._v(" "),(data.es_date == data.ee_date)?_c('div',[_c('span',{staticClass:"text-mobile-small"},[_vm._v("\n                        "+_vm._s(_vm.moment(data.es_date).format("MMM. D, YYYY"))+"\n                      ")])]):_c('div',{staticClass:"text-truncate"},[_c('span',{staticClass:"text-mobile-small"},[_vm._v("\n                        "+_vm._s(_vm.moment(data.es_date).format("MMM. D, YYYY"))+" -\n                        "+_vm._s(_vm.moment(data.ee_date).format("MMM. D, YYYY"))+"\n                      ")])])]),_vm._v(" "),_c('div',[_c('div',[_c('p',{staticClass:"text-pink font-weight-bold text-right"},[_vm._v("\n                        "+_vm._s(data.currency)+"\n                        "+_vm._s(data.price)+"\n                        "),(data.seat_type_count > 1)?_c('span',[_vm._v("Onwards")]):_vm._e()])])])])])])}),0)]),_vm._v(" "),_c('b-tab',{attrs:{"title":"Coming Soon"}},[_c('div',{staticClass:"row row-flex event-row-left-right row-cols-4"},_vm._l((this.upCommingEvents),function(data,index){return _c('div',{key:index,staticClass:"col-6 col-sm-4 col-md-3 col-lg-3 px-lg-1 px-2"},[_c('div',{staticClass:"event-card",on:{"click":function($event){return _vm.goToEventDetails(data)}}},[_c('img',{staticClass:"w-100 event-image-ht",attrs:{"src":_vm.base_url + data.e_image}}),_vm._v(" "),_c('div',{staticClass:"event-card-details"},[_c('div',[_c('h6',{staticClass:"mb-0 text-truncate text-mobile-head"},[_vm._v("\n                      "+_vm._s(data.e_name)+"\n                    ")]),_vm._v(" "),(data.es_date == data.ee_date)?_c('div',[_c('span',{staticClass:"text-mobile-small"},[_vm._v("\n                        "+_vm._s(_vm.moment(data.es_date).format("MMM. D, YYYY"))+"\n                      ")])]):_c('div',[_c('span',{staticClass:"text-mobile-small"},[_vm._v("\n                        "+_vm._s(_vm.moment(data.es_date).format("MMM. D, YYYY"))+" -\n                        "+_vm._s(_vm.moment(data.ee_date).format("MMM. D, YYYY"))+"\n                      ")])])]),_vm._v(" "),_c('div',[_c('div',[_c('p',{staticClass:"text-pink font-weight-bold text-right"},[_vm._v("\n                        "+_vm._s(data.currency)+"\n                        "+_vm._s(data.price)+"\n                      ")])])])])])])}),0)])],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/22.04b4aa0add1e0b078c9c.js